import React from "react";
import * as E from "../../elementor";
import parse from "html-react-parser";
import InteractiveCard from "./interactive-card";

interface Props {
  section: E.Section;
}

export const InteractiveCardGroup: React.FC<Props> = ({ section }) => {
  const { textEditor, heading, image, button, basicGallery } = E.collect(section);

  const mainHeading = heading.shift();
  const mainSubHeading = textEditor.shift();

  return (
    <div className="interactive-cards-group" data-testid='interactive-cards-group'>
      <div className="interactive-cards-group-content">
        <h2 className="headline">{parse(mainHeading?.title || "")}</h2>
        <p className="subheadline">{mainSubHeading?.parse()}</p>
      </div>
      <div className="image-gallery">
        {basicGallery?.[0]?.images.map((image, idx) => {
          const style = idx === 1 ? "large-image" : "small-image";
          return <img key={idx} src={image.fileUrl} className={style} />
        })}
      </div>
      <div className="cards" data-testid='cards'>
        {heading.map((heading, idx) => {
          return (
            <InteractiveCard
              text={textEditor[idx]}
              heading={heading}
              icon={image[idx]}
              button={button[idx]}
              key={idx}
            />
          );
        })}
      </div>
    </div>
  );
};

export default InteractiveCardGroup;
